import { MenuItem, Select, Stack, Typography } from '@mui/material'

import { LENIENCY_OPTIONS, type LeniencyCard } from '@/models/card-activity/card-activity.model'

export function LeniencySelect({
  difficulty,
  onChange,
  icon,
}: {
  difficulty: LeniencyCard
  onChange: (value: LeniencyCard) => void
  icon?: JSX.Element
}) {
  return (
    <Select
      renderValue={value => {
        const selectedOption = LENIENCY_OPTIONS.find(option => option.value === value)

        if (!selectedOption) return ''

        return (
          <Stack alignItems="center" direction="row" gap={1}>
            {icon}
            <Typography fontWeight="medium">{selectedOption.label.split(' - ')[0]}</Typography>
          </Stack>
        )
      }}
      size="small"
      sx={{
        borderRadius: '16px',
        '& .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #D0D5DD !important',
          borderRadius: '16px !important',
        },
        '& .MuiInputBase-input': {
          padding: '14px',
          color: '#344054',
          fontWeight: 500,
        },
        '&.MuiInputBase-root': {
          height: 44,
          background: '#FFF',
          width: '100%',
        },
      }}
      value={difficulty}
      onChange={e => {
        onChange(e.target.value as LeniencyCard)
      }}
    >
      {LENIENCY_OPTIONS.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  )
}
